import { Popover } from "antd";
import styled from "styled-components";
import PropTypes from "prop-types";
import { Box } from "@mui/material";

const PopoverContent = styled.div`
  padding: 8px;
  background-color: white;
  border-radius: 12px;
  font-family: 'Manrope', sans-serif;

  .name {
    font-weight: 600;
    font-size: 14px;
    color: #48566b;
    margin-bottom: 6px;
  }

  .status {
    font-size: 11px;
    font-weight: 500;
    color: #5a6c87;
    text-transform: capitalize;
    display: flex;
    align-items: center;
    gap: 6px;

    .pending {
      font-size: 14px;
      font-weight: 500;
      border-radius: 22px;
      padding: 6px 10px;
      background-color: #f1f6fe;
      color: #0c53bb;
    }

    .approved {
      font-size: 14px;
      font-weight: 500;
      border-radius: 22px;
      padding: 6px 10px;
      background-color: #e6f7e9;
      color: #2e7d32;
    }

    .rework {
      font-size: 14px;
      font-weight: 500;
      border-radius: 22px;
      padding: 6px 10px;
      background-color: #ffe4d5;
      color: #cd5f24;
    }
  }
`;

const STATUS_LABELS = {
  pending: "Review Pending",
  rework: "Rework Requested",
  approved: "Approved",
};

const CustomPopover = ({
  name,
  status,
  children,
  placement = "bottom",
  trigger = "hover",
}) => {
  const statusKey = status?.toLowerCase();
  const content = (
    <PopoverContent>
      <div className="name">{name}</div>
      {status && (
        <div className="status">
          Status - <span className={statusKey}>{STATUS_LABELS[statusKey]}</span>
        </div>
      )}
    </PopoverContent>
  );

  return (
    <Box>
      <Popover
        content={content}
        placement={placement}
        trigger={trigger}
        arrow={false}
        styles={{
          body: { padding: status ? "12px" : "0px" },
          popover: { marginTop: "36px" },
        }}
      >
        {children}
      </Popover>
    </Box>
  );
};

CustomPopover.propTypes = {
  name: PropTypes.string.isRequired,
  status: PropTypes.oneOf(["pending", "approved", "rework"]),
  children: PropTypes.node.isRequired,
  placement: PropTypes.oneOf([
    "top",
    "left",
    "right",
    "bottom",
    "topLeft",
    "topRight",
    "bottomLeft",
    "bottomRight",
    "leftTop",
    "leftBottom",
    "rightTop",
    "rightBottom",
  ]),
  trigger: PropTypes.oneOf(["hover", "focus", "click", "contextMenu"]),
};

export default CustomPopover;
